// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2OS_r","unreadBadge":"styles_unreadBadge__2v3As","modalContent":"styles_modalContent__3EmJK","modal":"styles_modal__28j7o"};